import Field from '../Field'
import moment from 'moment'

export default class extends Field {
  static name = 'date time'

  mutator (value) {
    if (value instanceof Date) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    } else if (value instanceof Object && value.date) {
      return this.mutator(new Date(value.date.replace(/\s+/g, 'T')))
    } else if (typeof value === 'string' && moment(value).format() !== 'Invalid date') {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    } else if (typeof value === 'string' && moment(value, 'YYYY-MM-DD HH:mm:ss') !== 'Invalid date') {
      return moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
    } else if (value === null) {
      return null
    }

    return undefined
  }
}
